import bossSCommon from '@/lib/bossSCommon'

/**
 * インタビュープレビューPC/SP共通 mixin
 */
export default {
  mixins: [bossSCommon],
  data () {
    return {
      interview: {
        companyName: '',
        catchCopy: '',
        image: null,
        intervieweePosition: '',
        intervieweeName: '',
        intervieweeProfile: '',
        contentList: []
      }
    }
  },
  computed: {
    id () {
      return Number(this.$route.params.id)
    }
  },
  created () {
    this.fetchInterview()
  },
  methods: {
    fetchInterview () {
      this.$http.secured.get(this.apiPathForInterview).then(response => {
        this.$set(this, 'interview', response.data)
      })
    }
  }
}
